(function () {
    'use strict';

    function setupMobileMenu() {
        const mobileMenuButton = document.getElementById("mobile-menu-button");
        const closeMenuButton = document.getElementById("close-menu-button");
        const mobileMenu = document.getElementById("mobile-menu");

        function toggleMobileMenu() {
            mobileMenu.classList.toggle("translate-x-full");
            mobileMenu.classList.toggle("translate-x-0");
        }

        if (mobileMenuButton) mobileMenuButton.addEventListener("click", toggleMobileMenu);
        if (closeMenuButton) closeMenuButton.addEventListener("click", toggleMobileMenu);
    }

    function resizeImages() {
        document.querySelectorAll(".image-container img").forEach(img => {
            img.style.objectFit = "cover";
            img.style.width = "100%";
            img.style.height = "100%";
        });
    }

    function getParamObjectFromHiddenFields() {

        const getString = (id, fallback = null) => {
            const el = document.getElementById(id);
            return el && el.value !== "" ? el.value : fallback;
        };

        const clickedFilterVal = getString("clickedFilter");

        return {
            idMake: getString("idMake"),
            idCategory: getString("idCategory"),
            idClass: getString("idClass"),
            idEngineFuel: getString("idEngineFuel"),
            idState: getString("idState"),
            idCity: getString("idCity"),
            idHullMaterial: getString("idHullMaterial"),
            usedNew: getString("usedNew"),
            priceFrom: getString("priceFrom", "0"),
            priceTo: getString("priceTo", "99999"),
            priceRange: [getString("priceFrom", "0"), getString("priceTo", "99999")],
            yearFrom: getString("yearFrom"),
            yearTo: getString("yearTo"),
            yearRange: [getString("yearFrom", "-1"), getString("yearTo", "10000")],
            lengthFrom: getString("lengthFrom", "-1"),
            lengthTo: getString("lengthTo", "5000"),
            lengthRange: [getString("lengthFrom", "-1"), getString("lengthTo", "5000")],
            sortType: getString("sort"),
            pageNumber: getString("page", "1"),
            resultsCount: getString("count"),
            clickedFilter: clickedFilterVal
        };
    }

    function renderPagination(data) {
        const nav = document.getElementById("pagination");
        if (!nav) return;

        nav.innerHTML = ""; // clear old pagination

        const container = document.createElement("nav");
        container.className = "mt-10 flex justify-center items-center space-x-2 text-sm";

        const createLink = (urlObj, isButton = false) => {
            const a = document.createElement("a");
            a.href = urlObj.url;
            a.textContent = urlObj.title;
            a.className = "px-3 py-1 border rounded hover:bg-primary hover:text-white";

            if (urlObj.alt === "active") {
                a.classList.add("bg-primary", "text-white");
            }

            return a;
        };

        // Previous
        if (data.previous) {
            container.appendChild(createLink(data.previous));
        }

        // Page numbers
        if (data.paginationUrls && Array.isArray(data.paginationUrls)) {
            data.paginationUrls.forEach(url => {
                container.appendChild(createLink(url));
            });
        }

        // Next
        if (data.next) {
            container.appendChild(createLink(data.next));
        }

        nav.appendChild(container);
    }

    function renderSortDropdown(sorters, currentSortType) {
        const select = document.getElementById("sortDropdown");
        if (!select || !Array.isArray(sorters)) return;

        select.innerHTML = ""; // clear existing options

        sorters.forEach(sorter => {
            const option = document.createElement("option");
            option.value = sorter.url;
            option.textContent = sorter.title;

            // Mark as selected if it matches current sortType
            if (currentSortType != null && sorter.alt === currentSortType.toString()) {
                option.selected = true;
            }

            select.appendChild(option);
        });

        // Handle selection
        select.addEventListener("change", (e) => {
            const selectedUrl = e.target.value;
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        });
    }

    function fetchAndRenderFilters() {
        const payload = getParamObjectFromHiddenFields();

        fetch("/api/qsdata-result", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        })
            .then(res => res.json())
            .then(data => {
                renderFilterBlock("Price", data.prices, "price-filter");
                renderFilterBlock("Length", data.lengths, "length-filter");
                renderFilterBlock("Year", data.years, "year-filter");
                renderFilterBlock("Condition", data.usedNew, "usednew-filter");
                renderPagination(data.paginationUrls);
                renderSortDropdown(data.sorters, payload.sortType);
            })
            .catch(err => console.error("Error fetching filters:", err));
    }

    function renderFilterBlock(title, items, containerId) {
        if (!items || items.length === 0) return;

        const targetMap = {
            "price-filter": ["desktop-spec-price", "mobile-price-filter"],
            "length-filter": ["desktop-spec-length", "mobile-length-filter"],
            "year-filter": ["desktop-spec-year", "mobile-year-filter"],
            "usednew-filter": ["desktop-spec-usednew", "mobile-usednew-filter"]
        };

        const containerIds = targetMap[containerId] || [containerId];

        containerIds.forEach(id => {
            const container = document.getElementById(id);
            if (!container) {
                console.warn("Container not found:", id);
                return;
            }

            container.innerHTML = "";

            const section = document.createElement("section");
            section.className = "filter-section";

            const heading = document.createElement("h3");
            heading.textContent = title;
            heading.className = "filter-section__title";

            const ul = document.createElement("ul");
            ul.className = "filter-section__list";

            items.forEach(item => {
                const li = document.createElement("li");
                const a = document.createElement("a");

                a.href = item.url;
                a.textContent = item.title;

                a.className = "block hover:text-primary";

                // Append count if present
                if (item.alt) {
                    const span = document.createElement("span");
                    span.textContent = ` (${item.alt})`;
                    a.appendChild(span);
                }

                li.appendChild(a);
                ul.appendChild(li);
            });

            section.appendChild(heading);
            section.appendChild(ul);
            container.appendChild(section);
        });
    }

    document.addEventListener("DOMContentLoaded", () => {
        setupMobileMenu();
        resizeImages();

        const toggleBtn = document.getElementById("toggle-filters");
        const mobilePanel = document.getElementById("mobile-filters");
        const closeBtn = document.getElementById("close-filters");
        const backdrop = document.getElementById("mobileFiltersBackdrop");
        const applyBtn = document.getElementById("mobileApplyFilters");
        const resetBtn = document.getElementById("mobileResetFilters");
        const summaryEl = document.getElementById("mobileFiltersSummary");

        let filtersAlreadyLoaded = false;
        const ensureFilters = () => {
            if (!filtersAlreadyLoaded) {
                fetchAndRenderFilters();
                filtersAlreadyLoaded = true;
            }
        };

        const openPanel = () => {
            if (mobilePanel) {
                mobilePanel.classList.add("is-open");
            }
            if (backdrop) {
                backdrop.hidden = false;
                backdrop.classList.add("is-active");
            }
            document.body.style.overflow = "hidden";
            ensureFilters();
            updateMobileSummary(summaryEl);
        };

        const closePanel = () => {
            if (mobilePanel) {
                mobilePanel.classList.remove("is-open");
            }
            if (backdrop) {
                backdrop.classList.remove("is-active");
                setTimeout(() => backdrop.hidden = true, 250);
            }
            document.body.style.overflow = "";
        };

        if (toggleBtn) toggleBtn.addEventListener("click", openPanel);
        if (closeBtn) closeBtn.addEventListener("click", closePanel);
        if (backdrop) backdrop.addEventListener("click", closePanel);
        if (applyBtn) applyBtn.addEventListener("click", closePanel);

        if (resetBtn) {
            resetBtn.addEventListener("click", () => {
                const target = resetBtn.dataset.resetUrl || window.location.pathname;
                window.location.href = target;
            });
        }

        ensureFilters();
        initCompareDrawer();
    });

    function updateMobileSummary(summaryEl) {
        if (!summaryEl) return;
        const chips = document.getElementById("appliedChips");
        const count = chips ? chips.children.length : 0;
        summaryEl.textContent = count ? `${count} filter${count > 1 ? "s" : ""} active` : "No filters applied";
    }

    const COMPARE_KEY = "boatCompare";
    const MAX_COMPARE = 2;

    function initCompareDrawer() {
        const buttons = Array.from(document.querySelectorAll(".compare-toggle"));
        if (!buttons.length) return;

        let selections = loadSelections();
        const drawer = document.getElementById("compareDrawer");
        const listEl = document.getElementById("compareList");
        const countEl = document.getElementById("compareCount");
        const clearBtn = document.getElementById("compareClear");

        const syncButtons = () => {
            buttons.forEach(btn => {
                const isActive = selections.some(item => item.id === btn.dataset.id);
                btn.classList.toggle("is-active", isActive);
                btn.textContent = isActive ? "Remove" : "Compare";
            });
        };

        const renderDrawer = () => {
            if (!drawer || !listEl || !countEl) return;
            countEl.textContent = selections.length;
            if (!selections.length) {
                drawer.classList.remove("is-visible");
                listEl.innerHTML = "";
                document.body.classList.remove("has-compare-drawer");
                return;
            }

            document.body.classList.add("has-compare-drawer");
            drawer.classList.add("is-visible");
            listEl.innerHTML = selections.map(item => {
                const tone = item.badgeTone || "neutral";
                const label = item.badgeLabel || "No market data";
                const desc = item.badgeDesc || "Add more details for deeper insight";
                return `
                <article class="compare-card price-badge--${tone}">
                    <div class="compare-card__heading">
                        <p class="compare-card__title">${item.title}</p>
                        <button type="button" class="compare-remove" data-remove-id="${item.id}">×</button>
                    </div>
                    <p class="compare-card__price">${item.price}</p>
                    <p class="compare-card__badge">${label}</p>
                    <p class="compare-card__desc">${desc}</p>
                    <div class="compare-card__actions">
                        <a href="${item.detailUrl}" class="compare-view" target="_blank" rel="noopener">View details</a>
                    </div>
                </article>`;
            }).join("");
        };

        const saveSelections = () => {
            try {
                localStorage.setItem(COMPARE_KEY, JSON.stringify(selections));
            } catch (err) {
                console.warn("Compare storage failed", err);
            }
        };

        buttons.forEach(btn => {
            btn.addEventListener("click", () => {
                const id = btn.dataset.id;
                const existing = selections.find(item => item.id === id);
                if (existing) {
                    selections = selections.filter(item => item.id !== id);
                } else {
                    if (selections.length >= MAX_COMPARE) {
                        alert("You can only compare two boats at a time.");
                        return;
                    }
                    selections.push({
                        id,
                        title: btn.dataset.title || "",
                        price: btn.dataset.price || "",
                        detailUrl: btn.dataset.detailUrl || "#",
                        badgeLabel: btn.dataset.badgeLabel || "",
                        badgeDesc: btn.dataset.badgeDesc || "",
                        badgeTone: btn.dataset.badgeTone || "neutral"
                    });
                }
                saveSelections();
                syncButtons();
                renderDrawer();
            });
        });

        if (clearBtn) {
            clearBtn.addEventListener("click", () => {
                selections = [];
                saveSelections();
                syncButtons();
                renderDrawer();
            });
        }

        if (listEl) {
            listEl.addEventListener("click", (evt) => {
                const target = evt.target.closest(".compare-remove");
                if (!target) return;
                const id = target.dataset.removeId;
                selections = selections.filter(item => item.id !== id);
                saveSelections();
                syncButtons();
                renderDrawer();
            });
        }

        syncButtons();
        renderDrawer();
    }

    function loadSelections() {
        try {
            const raw = localStorage.getItem(COMPARE_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (err) {
            console.warn("Compare storage parse failed", err);
            return [];
        }
    }

}());
